import { useCallback } from 'react';
import uuid from 'uuid/v1';
import { DEFAULT_NEW_EVENT_STRUCTURE } from 'modules/codeless-events/consts/defaultEventValues';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';

export const useDraftConversion = () => {
    const {
        value: draftEvent,
        onChange: setDraftEventInForm,
        resetFieldToInitial: resetDraftFieldToGlobalInitial,
    } = useFormFieldValue({ field: 'codelessDraftEvent' });

    const initializeDraftForNew = useCallback(() => {
        const tempId = uuid();
        const newEvent = {
            id: tempId,
            ...DEFAULT_NEW_EVENT_STRUCTURE,
        };
        setDraftEventInForm(newEvent);
        return tempId;
    }, [setDraftEventInForm]);

    const initializeDraftForEdit = useCallback(
        eventToEdit => {
            setDraftEventInForm({ ...eventToEdit });
        },
        [setDraftEventInForm]
    );

    const updateDraftEvent = useCallback(
        updaterOrValue => {
            setDraftEventInForm(updaterOrValue);
        },
        [setDraftEventInForm]
    );

    const clearAndResetDraft = useCallback(() => {
        resetDraftFieldToGlobalInitial();
    }, [resetDraftFieldToGlobalInitial]);

    return {
        draftEvent,
        initializeDraftForNew,
        initializeDraftForEdit,
        updateDraftEvent,
        clearAndResetDraft,
    };
};
